import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Number = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary[800],
}))

Number.defaultProps = {
  variant: 'Lato Body 1',
  display: 'inline',
}
